import { useState, useEffect } from 'react'

export const usePLPState = (categoryUid: string) => {
    const [activeLabel, setActiveLabel] = useState('')
    const [isSortVisible, setIsSortVisible] = useState(false)

    // Reset on category change
    useEffect(() => {
        setActiveLabel('Nuevo')
    }, [categoryUid])

    return {
        activeLabel,
        setActiveLabel,
        isSortVisible,
        setIsSortVisible
    }
}
